module.exports = __webpack_public_path__ + "static/img/h5Bg.e0ac187.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/anniversary/h5Bg.png
// module id = iuIb
// module chunks = 0